import ColFormItemWrapper from "../CustomForm/ColWFormItemWrapper";
import { Button, Col, DatePicker, Input, Modal, Row, Form } from "antd";
import dayjs, {
  dateCustomFormat,
  generalFormatAntd,
} from "../../../utils/dayjs";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { TimePicker } from "antd";
import { daysJsFormat } from "../../../utils/constants";
import "./CustomDateTimePicker.css";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";

export const CustomDateTimePicker = ({
  item,
  index,
  refForm,
  disabled,
  onValuesChange,
}) => {
  const [dateTime, setDateTime] = useState(dayjs());

  const inputRef = useRef(null); // Reference for the input container
  const timeContainerRef = useRef(null);

  const { isMobile } = useDeviceDetect();

  useEffect(() => {
    let initValue = "";

    if (typeof item.value === "string" || item.value instanceof String) {
      initValue = dayjs(item.value);
    } else {
      initValue = item.value;
    }

    setDateTime(initValue);
  }, []);

  const triggerOnSelect = (value, p) => {
    refForm.current.setFieldsValue({ [item.name]: value });
    item?.onChange(value);

    setDateTime(value);
  };

  const timePickerOnChange = e => {
    console.log(e);
    refForm.current.setFieldsValue({ [item.name]: e });
    item?.onChange(e);
    setDateTime(e);
  };

  const getPickerContainer = () => {
    if (isMobile) {
      return () => document.getElementById("time-picker-modal");
    }
    return () => document.body;
  };

  const handleFocus = id => {
    const element = document.getElementById(id);
    const elementRect = element.getBoundingClientRect();
    const offsetY =
      window.scrollY + elementRect.top - window.innerHeight * 0.25;
    window.scrollTo({
      top: offsetY,
      behavior: "smooth",
    });
  };

  const onChange = () => {
    // const timeInputValue =
    //   timeContainerRef.current.firstChild.firstChild.firstChild.value;
  };

  const handleBlurTimeInput = input => {
    if (!input) {
      return;
    }

    // Étape 1 : Nettoyage de l'entrée
    let cleanedInput = input.replace(/[^0-9:]/g, ""); // Retire tout sauf les chiffres et ":"

    // Étape 2 : Ajout des séparateurs manquants
    if (/^\d{3,4}$/.test(cleanedInput)) {
      // Ex : 1400 -> 14:00
      cleanedInput = cleanedInput.replace(/(\d{2})(\d{2})/, "$1:$2");
    } else if (/^\d{1,2}$/.test(cleanedInput)) {
      // Ex : 12 -> 12:00
      cleanedInput = `${cleanedInput.padStart(2, "0")}:00`;
    }


    // Étape 3 : Validation avec dayjs
    const timeFormat = "HH:mm"; // Format attendu
    const isValidFormat = /^([01]\d|2[0-3]):([0-5]\d)$/.test(cleanedInput); // Validation manuelle du format

    if (!isValidFormat) {
      console.error("Invalid time format:", cleanedInput);
      return;
    }

    // Étape 4 : Création d'une date complète avec l'heure
    const baseDate = dayjs(refForm.current.getFieldValue(item.name)); // Récupère la date existante du DatePicker
    const fullDateTime = baseDate
      .hour(parseInt(cleanedInput.split(":")[0], 10))
      .minute(parseInt(cleanedInput.split(":")[1], 10));

    if (!fullDateTime.isValid()) {
      console.error("Invalid full date-time:", fullDateTime);
      return;
    }

    // Étape 5 : Mise à jour de l'état et du formulaire
    setDateTime(fullDateTime); // Mets à jour l'état local
    refForm.current.setFieldsValue({ [item.name]: fullDateTime }); // Mets à jour le formulaire
    item?.onChange(fullDateTime); // Appelle le callback personnalisé
  };
  return (
    <Col span={item.col}>
      <div id="time-picker-container">
        <Row ref={inputRef}>
          <ColFormItemWrapper
            item={{ ...item, col: 16 }}
            index={index}
            refForm={refForm}
          >
            <DatePicker
              //locale={frFR}
              onClick={() => handleFocus("time-picker-container")}
              value={dateTime}
              suffixIcon={item.suffixIcon}
              addonAfter={item.addonAfter}
              disabledDate={item?.disabledDate ? item.disabledDate : null}
              disabledTime={
                item?.disabledDateTime ? item.disabledDateTime : null
              }
              format={dateCustomFormat}
              onChange={triggerOnSelect}
              onFocus={() => handleFocus("time-picker-container")}
              onValueChange={triggerOnSelect}
              onCalendarChange={triggerOnSelect}
              allowClear={
                item.allowClear !== undefined ? item.allowClear : false
              }
              style={{ width: "100%" }}
              disabled={item.disabled || disabled}
            />
          </ColFormItemWrapper>
          <ColFormItemWrapper
            item={{ ...item, col: 8, label: "" }}
            index={index}
            refForm={refForm}
          >
            <TimePicker
              key={item.name + "time-picker"}
              onFocus={() => handleFocus("time-picker-container")}
              style={{ width: "100%" }}
              popupClassName={"customTimePicker"}
              format={daysJsFormat.hour}
              allowClear={false}
              showOk={false}
              onMouseUp={() => handleFocus("time-picker-container")}
              onOpenChange={() => handleFocus("time-picker-container")}
              needConfirm={false}
              changeOnScroll={true}
              disabledDate={item?.disabledDate ? item.disabledDate : null}
              disabledTime={
                item?.disabledDateTime ? item.disabledDateTime : null
              }
              onChange={w => {
                // timePickerOnChange(w);
              }}
              onSelect={w => {
                // timePickerOnChange(w);
              }}
              onValueChange={w => {
                timePickerOnChange(w);
              }}
              onBlur={i => {
                handleBlurTimeInput(i.target.value);
              }}
              onKeyUp={e => {
              }}
              value={dateTime}
            />
          </ColFormItemWrapper>

          {/*{isMobile && (*/}
          {/*  <>*/}
          {/*    <Col span={6}>*/}
          {/*      <Form.Item label={""}>*/}
          {/*        <Input*/}
          {/*          style={{ width: "100%", marginTop: 40 }}*/}
          {/*          value={dateTime.format(daysJsFormat.hour)}*/}
          {/*          onClick={() => {*/}
          {/*            setPickerModalVisible(true);*/}
          {/*          }}*/}
          {/*          suffix={<ClockCircleOutlined />}*/}
          {/*        ></Input>*/}
          {/*      </Form.Item>*/}
          {/*    </Col>*/}
          {/*    <ColFormItemWrapper*/}
          {/*      item={{ ...item, col: 6, label: "" }}*/}
          {/*      index={index}*/}
          {/*      refForm={refForm}*/}
          {/*    >*/}
          {/*      <Modal*/}
          {/*        key={"modal-inpout-full"}*/}
          {/*        open={isPickerModalVisible}*/}
          {/*        destroyOnClose={true}*/}
          {/*        onCancel={() => setPickerModalVisible(false)}*/}
          {/*        footer={null}*/}
          {/*        width={190}*/}
          {/*        title={"Heure de fin"}*/}
          {/*        className="time-picker-modal"*/}
          {/*      >*/}
          {/*        <TimePicker*/}
          {/*          open={isPickerModalVisible}*/}
          {/*          style={{ width: "100%" }}*/}
          {/*          popupClassName={"customTimePicker"}*/}
          {/*          format={daysJsFormat.hour}*/}
          {/*          allowClear={false}*/}
          {/*          showOk={false}*/}
          {/*          needConfirm={false}*/}
          {/*          changeOnScroll={true}*/}
          {/*          onChange={timePickerOnChange}*/}
          {/*          onSelect={timePickerOnChange}*/}
          {/*          onValueChange={timePickerOnChange}*/}
          {/*          value={dateTime}*/}
          {/*          getPopupContainer={getPickerContainer()}*/}
          {/*        />*/}
          {/*      </Modal>*/}
          {/*    </ColFormItemWrapper>*/}
          {/*  </>*/}
          {/*)}*/}
        </Row>
      </div>
    </Col>
  );
};
